import { formatFullCurrencyBrl, formatPercentDisplay } from './managerial-kpis'

export type RevenueOriginId =
  | 'site'
  | 'referral'
  | 'affiliates'
  | 'paid-traffic'
  | 'unknown'

export type RevenueOriginSlice = {
  id: RevenueOriginId
  label: string
  color: string
  amount: number
}

export type RevenueOriginView = RevenueOriginSlice & {
  percent: number
  formattedPercent: string
}

export type RevenueOriginBreakdown = {
  total: number
  formattedTotal: string
  slices: RevenueOriginView[]
}

export const REVENUE_ORIGIN_META: Record<
  RevenueOriginId,
  { label: string; color: string }
> = {
  site: { label: 'Direto e orgânico', color: '#c4b5fd' },
  referral: { label: 'Indicação', color: '#818cf8' },
  affiliates: { label: 'Afiliados', color: '#4f46e5' },
  'paid-traffic': { label: 'Tráfego pago', color: '#1e1b4b' },
  unknown: { label: 'Não identificado', color: '#94a3b8' },
}

const ORIGIN_ORDER: RevenueOriginId[] = [
  'site',
  'referral',
  'affiliates',
  'paid-traffic',
  'unknown',
]

export function buildRevenueOriginBreakdown(
  amounts: Record<RevenueOriginId, number>
): RevenueOriginBreakdown {
  const slicesBase = ORIGIN_ORDER.map((id) => ({
    id,
    label: REVENUE_ORIGIN_META[id].label,
    color: REVENUE_ORIGIN_META[id].color,
    amount: amounts[id],
  }))

  const total =
    slicesBase.reduce((sum, slice) => sum + Math.round(slice.amount * 100), 0) / 100

  return {
    total,
    formattedTotal: formatFullCurrencyBrl(total),
    slices: slicesBase.map((slice) => {
      const percent = total === 0 ? 0 : (slice.amount / total) * 100
      return {
        ...slice,
        percent,
        formattedPercent: formatPercentDisplay(percent),
      }
    }),
  }
}
